import { Address, Msg, Network, Signer, Simulation, TxResult } from "rujira.js";
import { TronWeb } from "tronweb";

export interface TronLink {
  request: (v: { method: string }) => Promise<any>;
  tronWeb: TronWeb;
}

declare global {
  interface Window {
    tronLink?: TronLink;
  }
}
export type TronlinkContext = TronLink;

const BANDWIDTH_PRICE_SUN_PER_BYTE = 1;

export class Tronlink implements Signer {
  private tron: () => TronLink | undefined;

  constructor(tron: () => TronLink | undefined) {
    this.tron = tron;
  }
  async connect(): Promise<Address[]> {
    const t = this.tron();
    if (!t) throw new Error(`TronLink not found`);
    await t.request({ method: "tron_requestAccounts" });
    if (!t.tronWeb.defaultAddress.base58)
      throw new Error(`No account found on TronLink`);
    return [t.tronWeb.defaultAddress.base58];
  }
  async simulate(msg: Msg): Promise<Simulation> {
    const t = this.tron();
    if (!t) throw new Error(`TronLink not found`);
    const tx = msg.toTronTx(t.tronWeb);
    const txSizeBytes = JSON.stringify(tx).length;
    const bandwidth = await t.tronWeb.trx.getBandwidth(msg.account.address);

    const bandwidthRequired = Math.max(0, txSizeBytes - bandwidth);
    const bwCostSun = bandwidthRequired * BANDWIDTH_PRICE_SUN_PER_BYTE;

    return {
      symbol: "TRX",
      decimals: 6,
      amount: BigInt(bwCostSun),
      gas: BigInt(bwCostSun),
    };
  }
  async signAndBroadcast(_simulation: Simulation, msg: Msg): Promise<TxResult> {
    const t = this.tron();
    if (!t) throw new Error(`TronLink not found`);

    const tx = await msg.toTronTx(t.tronWeb);
    const signed = await t.tronWeb.trx.sign(tx);
    const res = await t.tronWeb.trx.sendRawTransaction(signed);
    return {
      network: "TRON",
      address: msg.account.address,
      txHash: res.txid,
      deposited: msg.toDeposit?.(),
    };
  }
  onChange?: ((cb: () => void) => void) | undefined;
  isAvailable() {
    return true;
  }
  public networks(): Network[] {
    return ["TRON"];
  }
}

export default new Tronlink(() => window.tronLink);
